var entity_store_state = {
  namespaced: true,
  state() {
    return {
      hasInitialData: false,
      entity: null
    };
  },
  mutations: {
    setEntity(state, entity) {
      state.hasInitialData = true;
      state.entity = entity;
    },
    removeEntity(state) {
      state.entity = null;
    }
  },
  getters: {
    getEntity: state => {
      return state.entity;
    },
    hasInitialData: state => {
      return state.hasInitialData;
    }
  },
  actions: {
    subscribe(context, subscribe) {
      var sub = subscribe.subscribe();
      return sub;
    }
  }
};

var currentSubscriptions = {};

let Vue = null;

function vueSet(array, key, value) {
  if (Vue) {
    Vue.set(array, key, value);
  } else {
    array[key] = value;
  }
}

function vueDelete(array, key) {
  if (Vue) {
    Vue.delete(array, key);
  } else {
    delete array[key];
  }
}

export default {
  namespaced: true,
  init: function (vue) {
    Vue = vue;
  },
  state() {
    return {
      initializedEntities: {}
    };
  },
  mutations: {
    setInitialized(state, store_path) {
      vueSet(state.initializedEntities, store_path, store_path);
    },
    setUninitialized(state, store_path) {
      vueSet(state.initializedEntities, store_path, null);
    }
  },
  getters: {
    initializedEntities(state) {
      return state.initializedEntities;
    }
  },
  actions: {
    subscribe(context, subscribe) {
      var id_str = subscribe.storePath;
      var existing_subscription = currentSubscriptions[id_str];

      let subscriber_data = {};

      if (existing_subscription == null) {
        var vuex_module_name = "entitystore/" + id_str;
        console.log("Registering entitystore vuex store at " + vuex_module_name);
        this.registerModule(vuex_module_name, entity_store_state);
        context.commit('setInitialized', id_str);
        var sub = context.dispatch(id_str + "/subscribe", subscribe);
        var sub_obj = {
          subscription: sub,
          subscriberData: []
        };

        sub_obj.unsubscribe = () => {
          let subscriber_data_index = sub_obj.subscriberData.indexOf(subscriber_data);
          sub_obj.subscriberData.splice(subscriber_data_index, 1);
          if (sub_obj.subscriberData.length == 0) {
            sub_obj.subscription.then(sub => sub.unsubscribe());
            console.log("Unregistering entitystore vuex store at " + vuex_module_name);
            this.unregisterModule(vuex_module_name);
            context.commit('setUninitialized', id_str);
            currentSubscriptions[id_str] = null;
          }
        };

        currentSubscriptions[id_str] = sub_obj;
        existing_subscription = sub_obj;
      }

      existing_subscription.subscriberData.push(subscriber_data);

      return {
        unsubscribe: existing_subscription.unsubscribe
      };
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/store/entitystore.js
// module id = null
// module chunks = 